module.exports = __webpack_public_path__ + "media/arg/bghead-6e117c9d.png";